import { render, staticRenderFns } from "./AreaChart.vue?vue&type=template&id=3294cf70&"
import script from "./AreaChart.vue?vue&type=script&lang=ts&"
export * from "./AreaChart.vue?vue&type=script&lang=ts&"
import style0 from "./AreaChart.vue?vue&type=style&index=0&id=3294cf70&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports